import { render, staticRenderFns } from "./DoctorConsultModal.vue?vue&type=template&id=5d07bcf6&scoped=true"
import script from "./DoctorConsultModal.vue?vue&type=script&lang=js"
export * from "./DoctorConsultModal.vue?vue&type=script&lang=js"
import style0 from "./DoctorConsultModal.vue?vue&type=style&index=0&id=5d07bcf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07bcf6",
  null
  
)

export default component.exports